var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5465 0C1.24645 0 0.969572 0.0904454 0.732982 0.24399L10.31 8.29561C10.8104 8.71628 11.34 8.71628 11.8404 8.29561L21.4337 0.24399C21.1971 0.0904454 20.9202 0 20.6202 0H1.5465ZM0.0886022 1.07692C0.032219 1.24519 0 1.42609 0 1.61538V12.3846C0 13.2796 0.689693 14 1.54651 14H20.6202C21.477 14 22.1667 13.2796 22.1667 12.3846V1.61538C22.1667 1.42608 22.1344 1.24519 22.0781 1.07692L12.4848 9.13715C11.6541 9.83441 10.4963 9.83549 9.6655 9.13715L0.0886022 1.07692Z",
    fill: "#6195A6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d7b427aa5ff76f6e283383d8b7b411a1.svg";
export { ForwardRef as ReactComponent };